import React, { FC, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { StarterRoutePath } from "./configs/_starter.route-path";
import starterRoutes from "./configs/_starter.routes";
import StarterAppLayout from "./features/layout/StarterAppLayout";
const StarterDashboard = React.lazy(
  () => import("./features/dashboard/StarterDashboard"),
);
import { MainAppsRepo } from "../Apps";

interface AppStarterProps {
  changeApp?: (app: MainAppsRepo) => void;
}

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const AppStarter: FC<AppStarterProps> = ({ changeApp }) => {
  return (
    <div className="starter">
      <Suspense fallback={loading}>
        <Routes>
          <Route
            path={StarterRoutePath.Home}
            element={<StarterAppLayout changeApp={changeApp} />}
          >
            {starterRoutes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    element={<route.component />}
                  />
                )
              );
            })}
            <Route
              path={StarterRoutePath.Home}
              element={<Navigate to={StarterRoutePath.Dashboard} />}
            />
            <Route
              path={StarterRoutePath.Dashboard}
              element={<StarterDashboard />}
            />
            <Route
              path="*"
              element={
                <Navigate to={StarterRoutePath.NotFoundError} replace={true} />
              }
            />
          </Route>
          <Route path="*" element={<Navigate to={StarterRoutePath.Home} />} />
        </Routes>
      </Suspense>
    </div>
  );
};
export default AppStarter;
